import { createSlice, createSelector, createAsyncThunk } from '@reduxjs/toolkit';
import { getAllOrderStatus } from '@Apis/order';
import { getColorAndIconByStatusId, groupOrderStatus } from '@Utils/orderHelpers';
import { groupInventoryBuy } from '@Utils/inventoryBuyHelper';
import { groupInventory } from '@Utils/inventoryHelper';
import { groupShipping } from '@Utils/shippingHelper';
import axiosService from '@Lib/axiosService';

export const getAllStatus = createAsyncThunk('order/getAllStatus', async (params, thunkApi) => {
  try {
    const { data } = await getAllOrderStatus();
    return data;
  } catch (error) {
    return thunkApi.rejectWithValue({ error: error.message });
  }
});

const mappingOrder = (item, index) => {
  let active = 0;
  if (index === 0) {
    active = 1;
  }
  return { ...item, active };
};

const mappingOrderHasChild = (item, index, status) => {
  const child = item.childId.reduce((acc, current) => {
    const check = status.find((childItem) => childItem.id === current);
    if (check) {
      acc.push(check);
    }
    return acc;
  }, []);

  if (child.length > 0) {
    child[0].active = 1;
    item.child = child;
  }
  let active = 0;
  if (index === 0) {
    active = 1;
  }
  return { ...item, active };
};

const orderSlice = createSlice({
  name: 'order',
  initialState: {
    status: [],
    groupStatus: [],
    hasChild: true,
    statusIdActive: 0,
  },
  reducers: {
    groupAllStatus: (state, action) => {
      const { type, statusId: requestedStatusId } = action.payload;
      const { status } = state;
      const objType = {
        order: {
          group: groupOrderStatus(),
          hasChild: true,
        },
        inventoryBuy: { group: groupInventoryBuy(), hasChild: false },
        inventory: { group: groupInventory(), hasChild: true },
        shipping: { group: groupShipping(), hasChild: false },
      };

      const { group, hasChild } = objType[type];
      const mappingGroup = group.map((item, index) => {
        if (hasChild) return mappingOrderHasChild(item, index, status);
        return mappingOrder(item, index);
      });
      let statusIdActive = requestedStatusId;
      if (statusIdActive === undefined) {
        if (type === 'order') {
          statusIdActive = 0;
        } else if (hasChild) {
          statusIdActive = mappingGroup[0]?.child?.[0]?.id || 0;
        } else {
          statusIdActive = mappingGroup[0]?.id || 0;
        }
      }
      let hasActiveStatus = false;

      if (hasChild && statusIdActive === 0) {
        const allStatus = mappingGroup.find((item) => item.name === 'Tất cả');
        if (allStatus) {
          allStatus.id = 0;
          allStatus.active = 1;
          hasActiveStatus = true;
        }
      } else if (hasChild) {
        mappingGroup.forEach((item) => {
          const activeChild = item.child?.find((child) => child.id === statusIdActive);
          item.active = activeChild ? 1 : 0;
          if (activeChild) {
            item.child = item.child.map((child) => ({
              ...child,
              active: child.id === statusIdActive ? 1 : 0,
            }));
            hasActiveStatus = true;
          }
        });
      } else {
        mappingGroup.forEach((item) => {
          item.active = item.id === statusIdActive ? 1 : 0;
          if (item.id === statusIdActive) hasActiveStatus = true;
        });
      }

      if (!hasActiveStatus) {
        statusIdActive = hasChild ? 0 : mappingGroup[0]?.id || 0;
      }
      state.statusIdActive = statusIdActive;
      state.hasChild = hasChild;
      state.groupStatus = mappingGroup;
    },
    setGroupAllStatus: (state, action) => {
      const data = action.payload;
      state.groupStatus = data;
    },
    setStatusActive: (state, action) => {
      const id = action.payload;
      const token = localStorage.getItem(process.env.TOKEN);
      axiosService.setHeader('Authorization', `Bearer ${token}`);
      state.statusIdActive = id;
    },
  },
  extraReducers: {
    [getAllStatus.fulfilled]: (state, action) => {
      let status = action.payload;
      const all = {
        id: 0,
        name: 'Tất cả',
      };
      status = [all, ...status];
      const statusMapped = status.map((item) => {
        const iconAndColor = getColorAndIconByStatusId(item.id);
        if (iconAndColor) {
          item = { ...item, ...iconAndColor };
        }
        return item;
      });
      state.status = statusMapped;
    },
  },
});

const { reducer } = orderSlice;

export const selectOrder = createSelector(
  (state) => ({
    order: state.order.status,
    groupStatus: state.order.groupStatus,
    defaultActive: state.order.defaultActive,
  }),
  (state) => state,
);

export const { groupAllStatus, setGroupAllStatus, setStatusActive } = orderSlice.actions;

export default reducer;
